import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  BLACKLIST_EMAILER_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/communicationManagement';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import SuperBatchSelect from 'components/SuperBatchSelect';

function SuperBatchFilter() {
  const dispatch = useDispatch();
  const { superBatch } = useSelector(currentFiltersSelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: BLACKLIST_EMAILER_FILTERS.superBatch,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Super Batch"
      labelClassName="h5"
    >
      <SuperBatchSelect
        styles={_styles}
        placeholder="Select from dropdown"
        value={superBatch}
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default SuperBatchFilter;
